import React from 'react';
import SearchCenterDialog from '../../../Component/Private/SearchCenterDialog/SearchCenterDialog';

const Search = () => {
  return <SearchCenterDialog isDialog={false} />;
};

export default Search;